var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 25.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e1dfba;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28,25.63H0V0H28ZM25,13.54a4.06,4.06,0,0,0-4-1.93,3.57,3.57,0,0,0-3.46,2.3,3.19,3.19,0,0,0,1.55,3.77c.6.35,1.28.6,1.93.9.5.23,1,.43,1.49.68a1,1,0,0,1,.61,1.1,1.15,1.15,0,0,1-.95.94,2.81,2.81,0,0,1-2.84-.66c-.21-.2-.4-.42-.62-.65l-2.14,1.13c.24.31.41.57.63.8a5.72,5.72,0,0,0,5.65,1.45,3.23,3.23,0,0,0,2.87-2.76,3.09,3.09,0,0,0-1.83-3.39c-.75-.39-1.56-.69-2.34-1a3.41,3.41,0,0,1-1.14-.64,1.29,1.29,0,0,1-.28-1.07,1.28,1.28,0,0,1,.86-.67,1.81,1.81,0,0,1,2,.93ZM7.37,21.46a3.9,3.9,0,0,0,3.44,2.19c2.33.23,4.35-.85,4.38-3.25,0-2.77,0-5.54,0-8.31a1.77,1.77,0,0,0-.05-.29H12.58v.67c0,2.54,0,5.09,0,7.63a1.18,1.18,0,0,1-.79,1.29,1.68,1.68,0,0,1-1.87-.55,7.05,7.05,0,0,1-.43-.57Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.a2aa73573ce713a70336089667e85f76.svg";
export { ForwardRef as ReactComponent };